import { cs } from './cs';
import { en } from './en';
import type { ConsentTexts, Language } from '../types';

export const translations: Record<Language, ConsentTexts> = {
  cs,
  en,
};

export const isLanguage = (value: unknown): value is Language => (
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(translations, value)
);
